import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "overview",
  class: "hero"
}
const _hoisted_2 = ["poster"]
const _hoisted_3 = { class: "hero-inner" }
const _hoisted_4 = { class: "hero-actions" }

import { ref } from 'vue'
import { useSmoothScroll } from '@/composables/useSmoothScroll'
import { useInlineAutoplayVideo } from '@/composables/useInlineAutoplayVideo'

import heroPosterImg from '@/assets/picture/Hero_section_first_frame.png'
const videoSrc = '/videos/XR-Robotics_Background.mp4'

export default /*@__PURE__*/_defineComponent({
  __name: 'HeroSection',
  setup(__props) {

const { scrollToId } = useSmoothScroll()
const heroVideoRef = ref<HTMLVideoElement | null>(null)

useInlineAutoplayVideo(heroVideoRef)

// Video background asset
// Using public directory for large video files
const heroPoster = heroPosterImg

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("video", {
      ref_key: "heroVideoRef",
      ref: heroVideoRef,
      class: "hero-video",
      autoplay: "",
      muted: "",
      loop: "",
      playsinline: "",
      "webkit-playsinline": "true",
      "x5-playsinline": "true",
      "x5-video-player-type": "h5",
      "x5-video-player-fullscreen": "false",
      preload: "auto",
      src: videoSrc,
      poster: _unref(heroPoster)
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "hero-title" }, "LabOS: The AI-XR Co-Scientist", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "hero-description" }, " Agentic AI that sees, reasons, and works with humans in real laboratories — linking dry-lab planning to wet-lab execution. ", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(scrollToId)('use')))
        }, "Use LabOS Now"),
        _createElementVNode("button", {
          class: "btn btn-secondary",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(scrollToId)('benchmark')))
        }, "Explore LSV Benchmark")
      ])
    ])
  ]))
}
}

})